
import './DialogTraiterInterruption.scss';

import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { DatePickerComponent, TextFieldComponent,Transition} from '../shared/ReusableSmallComponents';
function DialogInterompreMission({mission,openNestedInttreption, handleCloseNestedInterruption}) {
    DialogInterompreMission.propTypes = {
        mission: PropTypes.any,
        openNestedInttreption: PropTypes.any,
        handleCloseNestedInterruption: PropTypes.func,
    };
    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage } = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const { i18n } = useTranslation();
    const [motifInterruption,setMotifInterruption]=useState('');
    const  [dateEffective,setDateEffective]=useState(null);
    const {device}=useWindowSize();

    useEffect(() => {
        if (dateEffective) {
            console.log('dateEffective',dateEffective);
            const currentDate = moment();
            const nextMonthDate = currentDate.add(1, 'month');
            if( dateEffective < nextMonthDate)
                Swal.fire({
                    icon: 'warning',
                    confirmButtonColor: '#5CC889',
                    text: i18n.t('Le préavis pour interrompre une mission est d\'au moins un mois, voulez vous continuer quand même?'),
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: i18n.t('Oui'),
                    cancelButtonText: i18n.t('Non'),
                    customClass: {
                        container: 'swal-container',
                    },
                }).then((result) => {
                    if (result.dismiss) {
                        handleCloseNestedInterruption();
                    }
                });
        }
    }, [dateEffective]);

    const demandeInterruprion = async () => {
        try {
            const response1 = await axiosPrivate.post('/mission/demandeInterruprion',
                { missionId : mission?.id, motifInterruption,
                    // dateEffective3:  moment(dateEffective).format('YYYY-MM-DD'),
                    // dateEffective2: moment().utcOffset(dateEffective.utcOffset(), true),
                    // // * removes the offset correctly
                    // dateEffective4: dateEffective?.utc().add(moment().utcOffset(), 'minutes'),
                    // dateEffective1: moment(dateEffective)?.utc().toDate(),
                    dateEffective: dateEffective,
                },
            );
            // const responseData1 = await response1.data;
            console.log({response1,mission});
            setBackdropOpen(true);
            setSnackBarMessage(i18n.t(response1?.data?.message));
            handleCloseNestedInterruption();
            setBackdropOpen(false);
            setOpenSnackBar(true);
        } catch (error) {
            console.log(error.response?.status,error.response?.data.error);
            setBackdropOpen(true);
            setSnackBarMessage(i18n.t(error.response?.data.error));
            handleCloseNestedInterruption();
            setBackdropOpen(false);
            setOpenSnackBar(true);
        }
    };

    return (
        <div id='existing-dialog'>
            <Dialog
                open={openNestedInttreption}
                onClose={handleCloseNestedInterruption}
                fullScreen
                TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        background: '#FFFFFF',
                    },
                }}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <AppBar>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseNestedInterruption}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div  style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems:'center' ,minHeight:'900px',height:'100%', paddingBottom: '24px' }}>
                    <div className='OrdreMissionFileFrame18'>
                        <h5 className='OrdreMissionFileFrame19'>
                            {i18n.t('Demande d\'interruption de mission')}
                        </h5>
                        <div className='OrdreMissionFileFrame20'>
                            <div className='OrdreMissionFileFrame21'>
                                <div className='OrdreMissionFileFrame22'>
                                    <div className='OrdreMissionFileFrame23'>
                                        <p className='OrdreMissionFileFrame24'>{i18n.t('Date effective souhaitée de l\'interruption')} </p>
                                    </div>
                                    <div className='OrdreMissionFileFrame25'>
                                        <DatePickerComponent
                                            name="dateEffective"
                                            //label="Date de début/mission "
                                            date={dateEffective}
                                            setDate={(newValue) => {
                                                // console.log(moment().utcOffset());
                                                // moment(newValue)?.utc().toDate();
                                                setDateEffective(newValue);
                                                // setDateEffective(newValue?.utc());
                                                // setDateEffective(newValue);
                                            }}
                                            width={'100%'}
                                            disablePast
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className='OrdreMissionFileFrame26'>
                                <div className='OrdreMissionFileFrame23'>
                                    <p className='OrdreMissionFileFrame24'>{i18n.t('Motif de l\'interruption')} </p>
                                </div>
                                <div className='OrdreMissionFileFrame27'>
                                    <TextFieldComponent
                                        name="motifInterr"
                                        multiline
                                        minRows={4}
                                        value={motifInterruption}
                                        style={{width: '100%'}}
                                        onChange={(e) => setMotifInterruption(e.target.value)}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px'},
                                        }}
                                        //defaultValue=""
                                        autoFocus={true}
                                    // ref={userRef}
                                    //value={email}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='OrdreMissionFileFrame28'>
                            <Button
                                onClick={handleCloseNestedInterruption}
                                variant="text"
                                style={{...buttonStyles(false),...{width:device=='desktop'?'auto':'100%'}
                                }}
                            >{i18n.t('Annuler')}</Button>

                            <Button
                                variant="contained"
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}
                                }}
                                onClick={demandeInterruprion}
                            >{i18n.t('Valider')}</Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default DialogInterompreMission;
